import { useState, useCallback, useEffect } from 'react';

/**
 * useFormDirtyState — Hook de détection des modifications non enregistrées
 * 
 * Système de dirty flag explicite :
 * - hasUnsavedChanges: booléen indiquant si le formulaire a été modifié
 * - setDirty(): marque le formulaire comme modifié
 * - resetDirty(): réinitialise le flag (après save ou ouverture)
 * 
 * Inclut la protection beforeunload (fermeture onglet / refresh navigateur).
 */
const useFormDirtyState = () => {
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

  const setDirty = useCallback(() => {
    setHasUnsavedChanges(true);
  }, []);

  const resetDirty = useCallback(() => {
    setHasUnsavedChanges(false);
  }, []);

  // Protection navigateur: beforeunload
  useEffect(() => {
    if (!hasUnsavedChanges) return;

    const handler = (e) => {
      e.preventDefault();
      e.returnValue = '';
    };

    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  }, [hasUnsavedChanges]);

  return { hasUnsavedChanges, setDirty, resetDirty };
};

export default useFormDirtyState;
